var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function getPopularQueries(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const { urlService, limit } = options;
        // Load data
        const fetchOptions = { signal: options.signal };
        const [xsell, suggestions] = yield Promise.all([
            fetch(urlService.getSearchXsellUrl(limit), fetchOptions)
                .then((res) => res.json())
                .then(({ data }) => data)
                .catch(() => []),
            fetch(urlService.getSearchSuggestionsUrl(limit), fetchOptions)
                .then((res) => res.json())
                .then(({ data }) => data)
                .catch(() => []),
        ]);
        // Normalize and return data
        return [
            ...xsell,
            ...suggestions.map((query) => ({
                id: `suggestion:${query}`,
                label: query,
                query,
                order: -1,
                url: null,
            })),
        ];
    });
}
//# sourceMappingURL=getPopularQueries.js.map